import { useState } from "react";
import type { LoginCredentials } from "../../types/auth";
import { Alert, Button, Icon, Spinner } from "../atoms";
import { FormField } from "../molecules";

interface LoginFormProps {
  onLogin: (credentials: LoginCredentials) => Promise<void>;
  onSwitchToRegister: () => void;
  isLoading: boolean;
  error: string | null;
}

export function LoginForm({
  onLogin,
  // onSwitchToRegister,
  isLoading,
  error,
}: LoginFormProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onLogin({ email, password, force: true });
  };

  return (
    <div className="backdrop-blur-sm bg-white/95 border border-white/20 rounded-2xl shadow-2xl p-8 transform transition-all duration-300 hover:shadow-3xl animate-[fadeIn_0.6s_ease-out]">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-text-primary mb-2">Sign In</h2>
        <p className="text-text-secondary text-sm">
          Enter your credentials to continue
        </p>
      </div>

      {error && <Alert variant="error" message={error} className="mb-6" />}

      <form onSubmit={(e) => void handleSubmit(e)} className="space-y-6">
        <FormField
          id="email"
          type="email"
          label="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
          leftIcon={<Icon name="email" size="sm" />}
        />

        <FormField
          id="password"
          type="password"
          label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          required
          leftIcon={<Icon name="password" size="sm" />}
        />

        <div className="pt-2">
          <Button
            type="submit"
            variant="primary"
            size="large"
            state={isLoading ? "disabled" : "enabled"}
            fullWidth
          >
            <div className="flex items-center justify-center">
              {isLoading ? (
                <>
                  <Spinner size="sm" variant="white" className="mr-3" />
                  Signing in...
                </>
              ) : (
                <>
                  <Icon name="logout" size="sm" className="mr-2" />
                  Sign In
                </>
              )}
            </div>
          </Button>
        </div>
      </form>

      {/* <div className="mt-8">
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-border-light" />
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-4 bg-white text-text-muted">New to Treel?</span>
          </div>
        </div>
        
        <div className="mt-6 text-center">
          <Button
            onClick={onSwitchToRegister}
            variant="tertiary"
            size="medium"
            fullWidth
          >
            <div className="flex items-center justify-center">
              <Icon name="plus" size="sm" className="mr-2" />
              Create Account
            </div>
          </Button>
        </div>
      </div> */}
    </div>
  );
}
